import { Component, h, Host, Prop } from '@stencil/core';

@Component({
    tag: 'sew-ws-searchresult-list-item',
    styleUrl: 'sew-ws-searchresult-list-item.scss',
    shadow: true,
})
export class SewWsSerachresultListItem {
    @Prop() text: string;
    @Prop() isDoc: boolean;
    @Prop() fileLanguage: string;
    @Prop() fileType: string;
    @Prop() fileSize: string;
    @Prop() fileRelease: string;
    @Prop() fileLink: string;
    @Prop() partNumber: string;

    private formatText = (text: string): string => {
        const formattedText = text.replace(/\[strong\]/g, '<b>').replace(/\[\/strong\]/g, '</b>');

        return formattedText;
    };

    private getFileType = (link: string): string => link.split('.').pop().toUpperCase();

    render() {
        return (
            <Host>
                <sew-ws-link size="large">
                    <slot />
                </sew-ws-link>
                {this.isDoc && (
                    <p class="document-info">
                        {this.fileType && <span>{this.fileType}</span>}
                        {this.partNumber && <span>{this.partNumber}</span>}
                        {this.fileLanguage && <span>{this.fileLanguage.toLowerCase()}</span>}
                        {this.fileRelease && <span>{this.fileRelease}</span>}
                        {this.fileSize && (
                            <span>{this.getFileType(this.fileLink) + ' ' + this.fileSize}</span>
                        )}
                    </p>
                )}
                {this.text && <p innerHTML={this.formatText(this.text)}></p>}
            </Host>
        );
    }
}
